import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export const ARTICLES = [
	{
		slug: "qoo10-product-image-spec",
		title: "Qoo10 商品登録「画像が要件を満たしていません」正しいサイズと形式",
		description:
			"Qoo10で画像エラーが出る原因と、正しいサイズ・形式の設定方法を解説。最小400×400px、推奨800×800px。",
		date: "2026-03-16",
	},
	{
		slug: "amazon-product-image-size-2026",
		title:
			"Amazon商品画像サイズ 2026年最新 1000×1000以上が必須な理由と最適設定",
		description:
			"Amazon出品で1000×1000px以上が必要な理由（ズーム機能）と、推奨1600×1600px・白背景の設定方法。",
		date: "2026-03-16",
	},
	{
		slug: "rakuten-product-image-size-2026",
		title: "楽天市場 商品画像 推奨サイズ・形式・容量 2026年版まとめ",
		description:
			"楽天市場の商品画像要件（推奨700×700px、最大5MB、テキスト占有率20%以内）を2026年版で解説。",
		date: "2026-03-16",
	},
	{
		slug: "mercari-product-image-size-1200x900",
		title: "メルカリ 商品写真 最適サイズ 1200×900 余白なしで売れる画像の作り方",
		description:
			"メルカリで売れる商品写真のサイズ・余白なし・白背景の作り方。1080×1080px推奨、正方形で映える撮影テクニック。",
		date: "2026-03-16",
	},
	{
		slug: "aupay-product-image-size-640",
		title: "au PAYマーケット 商品画像サイズ 640×640 要件一覧と注意点",
		description:
			"au PAYマーケットの商品画像要件（640×640px以上、JPG/GIFのみ、2MB以内）を解説。PNG非対応の落とし穴も。",
		date: "2026-03-16",
	},
	{
		slug: "amazon-main-image-white-background-error",
		title:
			"「メイン画像の背景は白抜きにしてください」Amazon出品で弾かれた時の対処法",
		description:
			"Amazonセラーセントラルで「メイン画像の背景は白抜きにしてください」と弾かれる原因と、手順通りの対処法を解説。",
		date: "2026-03-16",
	},
	{
		slug: "amazon-image-requirements-not-met",
		title: "Amazon「商品画像が要件を満たしていません」エラーの原因と解決策",
		description:
			"Amazon出品時に「商品画像が要件を満たしていません」が出る全原因（背景色・解像度・ファイルサイズ）と解決手順。",
		date: "2026-03-16",
	},
	{
		slug: "rakuten-rms-image-size-error",
		title: "楽天RMS「画像サイズが規定外です」アップロードできない時の対処法",
		description:
			"楽天RMSで「画像サイズが規定外です」エラーが出る原因（サイズ・容量・形式）と即解決できる手順を解説。",
		date: "2026-03-16",
	},
	{
		slug: "mercari-image-upload-failed",
		title:
			"メルカリ「画像をアップロードできませんでした」重い画像を出品する方法",
		description:
			"メルカリで「画像をアップロードできませんでした」が出る原因（ファイルサイズ・形式）と、8MB超の画像を出品する方法。",
		date: "2026-03-16",
	},
	{
		slug: "yahoo-shopping-image-file-size-error",
		title:
			"Yahoo!ショッピング 商品画像「ファイルサイズが大きすぎます」の解決方法",
		description:
			"Yahoo!ショッピングで「ファイルサイズが大きすぎます」が出る原因（500KB/2MB制限）と即解決できる圧縮手順。",
		date: "2026-03-16",
	},
	{
		slug: "product-image-background-gray-solution",
		title: "商品画像の背景を白にしたいのに灰色になる — Photoshop以外の解決策",
		description:
			"背景除去後の画像が灰色になる原因（透明PNG）と、Photoshop不要でブラウザだけで白背景に変換する方法を解説。",
		date: "2026-03-16",
	},
	{
		slug: "removebg-free-limit-alternative-2026",
		title: "remove.bg 無料枠 使い切った 代替ツール 2026年版",
		description:
			"remove.bgの無料枠（月50枚・低解像度制限）を使い切った時に使える代替背景除去ツール5選を2026年版で比較。",
		date: "2026-03-16",
	},
	{
		slug: "transparent-png-to-white-jpeg-amazon",
		title: "背景透過したのにAmazonで白背景にならない PNG→JPEG変換の落とし穴",
		description:
			"背景除去後のPNGをJPEGに変換するとAmazonで白背景にならない原因（アルファチャンネル）と、正しく白背景JPEGを作る手順を解説。",
		date: "2026-03-16",
	},
	{
		slug: "background-removal-edge-precision",
		title: "髪の毛・細い部分が消える 背景除去ツール比較 — エッジ精度で選ぶ",
		description:
			"背景除去ツールで髪の毛・細かい部分が消える問題をエッジ精度で比較。remove.bg・PhotoRoom・Canva・Adobe Expressの精度を2026年版で解説。",
		date: "2026-03-16",
	},
	{
		slug: "smartphone-shadow-removal-guide",
		title: "スマホで撮った商品写真の影を消したい 白背景加工の最速手順",
		description:
			"スマホ撮影の商品写真に影が入る原因と、アプリ不要でブラウザだけで影を消して白背景に仕上げる最速手順を解説。",
		date: "2026-03-16",
	},
	{
		slug: "photo-background-remove-methods",
		title: "写真の背景を消す方法5選【PC・スマホ・無料対応】",
		description:
			"写真の背景を消す方法をPC・スマホ・無料ツールに分けて5選で解説。AIツールからPhotoshop代替まで、目的別に選べる背景除去の完全ガイド。",
		date: "2026-03-24",
	},
	{
		slug: "background-transparent-guide",
		title: "背景を透明にする方法【画像・動画・PowerPoint別】",
		description:
			"画像・動画・PowerPointで背景を透明にする方法を用途別に解説。AIツールからPowerPointの組み込み機能まで、透過処理の手順を詳しく紹介。",
		date: "2026-03-24",
	},
	{
		slug: "transparent-png-beginners-guide",
		title: "透過PNG（透明背景）の作り方と使い方【初心者向け完全ガイド】",
		description:
			"透過PNG（透明背景）の作り方を初心者向けに解説。AIツールで簡単に作る方法から、EC出品・PowerPoint・Webデザインでの正しい使い方まで網羅。",
		date: "2026-03-24",
	},
	{
		slug: "image-crop-free-tools-ai-speed",
		title: "画像を切り抜く無料ツール比較【AI自動切り抜きが一番速い理由】",
		description:
			"画像の切り抜き（背景除去）ができる無料ツールを徹底比較。AI自動切り抜きが手動より圧倒的に速い理由と、登録不要・無料で使えるおすすめツールを2026年版で解説。",
		date: "2026-03-24",
	},
	{
		slug: "background-transparent-site-free-top5-2026",
		title: "無料で使える背景透過サイトおすすめ5選【2026年最新比較】",
		description:
			"無料で使える背景透過サイトを2026年最新で比較。登録不要・制限なし・商用OKなど用途別に5つのサービスをランキング形式で紹介。EC出品・SNS・デザインに使えるおすすめを解説。",
		date: "2026-03-24",
	},
	{
		slug: "background-transparent-free-no-limit-no-signup",
		title: "完全無料で背景透過できる方法まとめ【回数制限なし・登録不要】",
		description:
			"完全無料で背景透過できる方法を回数制限なし・登録不要の観点でまとめ。ブラウザツール・デスクトップアプリ・スマホアプリを比較し、商用OKで使いやすいおすすめを解説。",
		date: "2026-03-24",
	},
];

export default function BlogIndex() {
	return (
		<>
			<Helmet>
				<title>EC商品画像 サイズ・規格ガイド | しろぬきや</title>
				<meta
					name="description"
					content="Amazon・楽天市場・メルカリ・Qoo10・au PAYマーケットの商品画像サイズ・規格・エラー対処法をまとめたガイド集。"
				/>
			</Helmet>
			<div className="max-w-3xl mx-auto px-4 py-10">
				<nav className="text-sm text-gray-500 mb-6">
					<Link to="/" className="hover:underline">
						ホーム
					</Link>
					{" > "}
					<span>ブログ</span>
				</nav>
				<h1 className="text-2xl font-bold mb-2">
					EC商品画像 サイズ・規格ガイド
				</h1>
				<p className="text-gray-600 text-sm mb-8">
					各モールの画像要件・エラー対処法をまとめた記事一覧です。
				</p>
				<ul className="space-y-6">
					{ARTICLES.map((article) => (
						<li key={article.slug} className="border-b pb-6">
							<Link
								to={`/blog/${article.slug}`}
								className="text-indigo-700 font-semibold hover:underline text-lg"
							>
								{article.title}
							</Link>
							<p className="text-gray-600 text-sm mt-1">
								{article.description}
							</p>
							<p className="text-gray-400 text-xs mt-1">{article.date}</p>
						</li>
					))}
				</ul>
			</div>
		</>
	);
}
